import React, {useContext, useEffect, useState} from "react";
import AlertIcon from "../../../icons/AlertIcon";
import WarningIcon from "../../../icons/WarningIcon";
import InfoIcon from "../../../icons/InfoIcon";
import AlertController from "../../../../stories/_news/Alerts/AlertController";
import AppContext from "../../../../context/AppContext";

const Alerts = () => {
	const { setEvent } = useContext(AppContext);
	const [ list, setList ] = useState([]);

	const refresh = () => {
		const controller = new AlertController();
		controller._callback = handleRefresh;
		controller.index();
	}
	const handleRefresh = (list, error, pagination, status) => {
		switch (status) {
			case 200:
				setList(list);
				break;
			default:
				setEvent({
					type: "error",
					text: "Une erreur s'est produite lors du chargement des alertes"
				});
				break;
		}
	}
	const buildIcon = alert => {
		switch (alert.type) {
			case "ALERT":
				return <AlertIcon />;
			case "WARNING":
				return <WarningIcon />;
			case "INFO":
				return <InfoIcon />;
			default:
				return <></>;
		}
	}

	useEffect(() => {
		refresh();
	}, []);

    return (
        <div className="block alerts">
			{
				list.map((alert, index) => (
					<div key={index} className={"alert " + alert.type}>
						{ buildIcon(alert) }
						<p>{ alert.text }</p>
					</div>
				))
			}
		</div>
    )
}

export default Alerts;
